import { __require as q } from "./toNumber.js";
var i, t;
function I() {
  if (t) return i;
  t = 1;
  var n = q(), e = 1 / 0, o = 17976931348623157e292;
  function f(r) {
    if (!r)
      return r === 0 ? r : 0;
    if (r = n(r), r === e || r === -1 / 0) {
      var _ = r < 0 ? -1 : 1;
      return _ * o;
    }
    return r === r ? r : 0;
  }
  return i = f, i;
}
export {
  I as __require
};
